import { cloneDeep as _cloneDeep, get as _get } from 'lodash-es';
import { getPlanDetail } from '@/management/api/plan';
import { getOfficer } from '@/management/api/userManage';
import { getPlanList } from '@/management/api/plan';
import { distributionList } from '@/management/api/plan';
import { planTypeOptions } from '@/management/pages/plan/config/index';
export default {
  async init({ state, dispatch, commit }, listType) {
    const planId = _get(state, 'planId');
    if (planId || planId !== state.planId) {
      await dispatch('getPlanFromRemote', listType);
    }
    // dispatch('resetState');
    commit('setPlanId', planId);
  },

  async getPlanFromRemote(
    { commit, dispatch, state },
    listType = 'distribution'
  ) {
    state.distributionListLoading = true;
    const res = await getPlanDetail(state.planId);
    if (res.code === 200) {
      const planMeta = res.data;
      document.title = planMeta.planName;
      if (listType === 'distribution') {
        const getOfficerRes = await getOfficer(state.searchOfficerName);
        if (state.saveOfficerTotal === 0) {
          // throw new Error('暂无可选调查员，请前往添加！');
          state.distributionListLoading = false;
          return;
        }
        let params = {
          planId: planMeta._id,
        };
        const allotList = await distributionList({ params });
        if (allotList.code && allotList.code !== 200) {
          throw new Error(res.msg);
        }
        // 根据分配任务记录获取对应调查员的分配情况
        const officerList = handleOfficers(getOfficerRes.data, allotList.data);
        commit('initPlan', {
          planMeta,
          officerList,
          allotList: allotList.data,
        });
        state.distributionListLoading = false;
      } else {
        commit('initPlan', {
          planMeta,
        });
        state.distributionListLoading = false;
      }
    } else {
      throw new Error(res.msg || '计划不存在');
    }
  },

  resetState({ commit, data }) {
    commit('setPlanId', null);
  },
};

// 调查员分配情况
function handleOfficers(officers, allotList) {
  return officers.map((item) => {
    const foundItem = allotList.find((subitem) => item.id === subitem._id);
    item.distrinutionFlag = foundItem ? foundItem.children.length > 0 : false;
    return { ...item };
  });
}
